const API = process.env.REACT_APP_BACKEND_URL;

export async function attrFetch(token, path, method = 'GET', body) {
  return apiFetch(token, `/merchants${path}`, method, body);
}

export async function apiFetch(token, path, method = 'GET', body) {
  const res = await fetch(`${API}/api${path}`, {
    method,
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = data.detail;
    throw new Error(typeof d === 'string' ? d : Array.isArray(d) ? d.map((e) => e.msg).join(' ') : d?.message || 'Request failed');
  }
  return data;
}

export const roleLabel = (r) => (r || '').split('_').map((w) => (w.toLowerCase() === 'iso' ? 'ISO' : w.charAt(0).toUpperCase() + w.slice(1))).join(' ');

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : 'current');

export const isAdmin = (role) => role === 'super_admin' || role === 'iso';

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
